module.exports = __webpack_public_path__ + "static/media/rm_06-40.9508d501.png";